import React, { useState, useEffect } from 'react';
import styles from './TemplateHero6.module.css';

const TemplateHero6 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Standard logic)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Images */}
      <div className={styles.imageLayer}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
            style={{ backgroundImage: `url('${slide.image}')` }}
          />
        ))}
      </div>

      {/* The Diagonal Geometric Panel */}
      <div className={styles.geometricPanel}></div>

      {/* Content Wrapper */}
      <div className={styles.contentArea}>
        <div className={styles.innerContent} key={`slide-${currentSlide}`}>
          <div className={styles.taglineBox}>
            <span className={styles.tagline}>Discover</span>
          </div>
          
          <div className={styles.titleMask}>
            <h1 className={styles.title}>{slides[currentSlide].title}</h1>
          </div>
          
          <div className={styles.subtitleMask}>
            <p className={styles.subtitle}>{slides[currentSlide].subtitle}</p>
          </div>

          <div className={styles.actionRow}>
            <button className={styles.btnSolid}>
              Get Started
            </button>
            <button className={styles.btnGhost}>
              Watch Video
            </button>
          </div>
        </div>
      </div>

      {/* Side Tab Indicators */}
      {slides.length > 1 && (
        <div className={styles.sideTabs}>
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.tab} ${index === currentSlide ? styles.activeTab : ''}`}
            >
              <span className={styles.tabIndex}>0{index + 1}</span>
              <div className={styles.tabProgress}></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateHero6;   